import SearchModel from'./SearchModel';
class ContactModel {
    id              = -1
    contactKey           = ""
    contactValue          = ""
    searchModel = null;
}

export default ContactModel